export default "__VITE_ASSET__wVDXiIOq__"